const ACTIVE_GROUP_STATUSES = ['paused', 'pending', 'queued', 'running'];

export function isActiveGroupDuplicate(
  existingTasks: Array<{
    id: string;
    marketplace_definition_id: string;
    keywords_text?: string;
    product_name?: string;
    status: string;
  }>,
  groupTaskIds: string[],
  marketplaceId: string,
  keywordsText: string,
  productName?: string
): boolean {
  const kw = (keywordsText || '').trim().toLowerCase();
  const product = (productName || '').trim().toLowerCase();
  const ids = new Set(groupTaskIds);
  return existingTasks.some(
    t =>
      ids.has(t.id) &&
      t.marketplace_definition_id === marketplaceId &&
      (t.keywords_text || '').trim().toLowerCase() === kw &&
      (!product || (t.product_name || '').trim().toLowerCase() === product) &&
      ACTIVE_GROUP_STATUSES.includes(t.status)
  );
}

export function replaceGroupTaskId(
  taskIds: string[],
  oldId: string,
  newId: string | null | undefined
): string[] {
  if (!newId || newId === oldId) return taskIds;
  return taskIds.map(id => (id === oldId ? newId : id));
}

export function isAddableAssembleMarketplace(
  def: {
    id: string;
    is_active?: boolean;
    is_template?: boolean;
  },
  alreadyIds: Set<string>
): boolean {
  if (!def?.id || alreadyIds.has(def.id)) return false;
  if (def.is_template) return false;
  return true;
}

export function filterSuggestedMarketplaces<
  T extends { name?: string; domain?: string; definition_id?: string },
>(marketplaces: T[], query: string): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return marketplaces;
  return marketplaces.filter(m =>
    [m.name, m.domain, m.definition_id]
      .filter((part): part is string => Boolean(part))
      .some(part => part.toLowerCase().includes(q))
  );
}

/** Select or clear only the ids currently in view, leaving the rest of the selection alone. */
export function selectFilteredMarketplaceIds(
  selectedIds: Iterable<string>,
  visibleIds: string[],
  allVisibleSelected: boolean
): Set<string> {
  const next = new Set(selectedIds);
  if (allVisibleSelected) {
    for (const id of visibleIds) next.delete(id);
  } else {
    for (const id of visibleIds) next.add(id);
  }
  return next;
}

export function assembleMarketplaceOptionLabel(def: {
  name?: string;
  domain?: string;
  country?: string | null;
}): string {
  const name = (def.name || def.domain || '').trim();
  const extra = [def.country, def.domain].filter(
    (part, i, arr) => part && arr.indexOf(part) === i && part !== name
  );
  return extra.length ? `${name} (${extra.join(', ')})` : name;
}

export function groupKeywordsByProduct(
  keywords: Array<{ text: string; product_name?: string | null }>
): Array<{ productName: string; keywords: string[] }> {
  const map = new Map<string, string[]>();
  for (const item of keywords) {
    const productName = (item.product_name || '').trim();
    if (!productName || !item.text.trim()) continue;
    const list = map.get(productName) || [];
    list.push(item.text.trim());
    map.set(productName, list);
  }
  return Array.from(map.entries()).map(([productName, kws]) => ({
    productName,
    keywords: kws,
  }));
}
